import { render, staticRenderFns } from "./SearchProjectBar.vue?vue&type=template&id=0277d8da&"
import script from "./SearchProjectBar.vue?vue&type=script&lang=ts&"
export * from "./SearchProjectBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports